module.exports = __webpack_public_path__ + "static/media/logo-fent-2.452be62d.png";